// LA TERMINAL COMPRADA, en JS puro · DISEÑO-F1b §7 (10 oct 2026).
// Lo que «Agregar terminal» y el aviso de Terminales comparten y se prueba
// sin montar nada.
import { codigoCompleto, normalizarCodigo } from './codigoDeTerminal';
import { leerEnlaceDeTerminal } from './enlaceDeTerminal';

/** El código que trae lo que leyó la cámara: un enlace `/T/…` o el código a secas. */
export function codigoDeLoEscaneado(texto) {
  const crudo = String(texto ?? '').trim();
  try {
    const u = new URL(crudo);
    const leido = leerEnlaceDeTerminal(u.pathname, u.search);
    if (leido?.tipo === 'VINCULAR') return leido.codigo;
  } catch { /* no era una dirección */ }
  // Una dirección que no es de la terminal no se convierte en código.
  if (/[/:.]/.test(crudo)) return null;
  // CORRECCIÓN (2.11.0, prueba P-27): el código suelto tiene que ser
  // EXACTAMENTE seis caracteres del alfabeto. Antes, un código de barras
  // de producto (7501234567890) perdía sus 0 y 1, se recortaba y salía
  // «752345»: se buscaba un código que nadie tecleó.
  const { codigo, rechazados } = normalizarCodigo(crudo, 64);
  return codigoCompleto(codigo) && !rechazados.length ? codigo : null;
}


export function textoDeLicencias(l) {
  if (!l || !(l.compradas > 0)) return null;
  const n = l.por_conectar;
  const titulo = n > 0
    ? `Tienes ${n} ${n === 1 ? 'terminal lista' : 'terminales listas'} para conectar`
    : `Tus ${l.compradas} ${l.compradas === 1 ? 'terminal comprada ya está conectada' : 'terminales compradas ya están conectadas'}`;
  const lineas = [];
  if (n > 0 && l.series_libres?.length) lineas.push(`Series: ${l.series_libres.join(', ')}`);
  if (l.reservadas > 0) {
    lineas.push(`Ya pediste el número para ${l.reservadas === 1 ? 'una' : l.reservadas}: tecléalo en la terminal, en «Tengo un código».`);
  }
  if (l.resto_en_consulta) lineas.push('Estaciones, andon y baldas siguen según tu plan; las ves en su pantalla.');
  return { titulo, lineas };
}
